import { Link } from "react-router-dom";
import "./Header.css";

const Header = ({ cartCount, user, onLogout, onOpenLogin }) => {
  return (
    <header className="header">
      <div className="header-top">
        <div className="header-container">
          <Link to="/" className="logo">
            <img src="/logo.png" alt="TorrePallets" className="logo-img" />
            <span className="logo-text">BioPallet</span>
          </Link>
          <div className="header-nav-right">
            <div className="user-section">
              {user ? (
                <div className="user-menu">
                  <span className="user-greeting">👤 Ciao, {user.name}</span>
                  <button
                    className="logout-btn"
                    onClick={onLogout}
                    title="Esci dal tuo account"
                  >
                    Esci
                  </button>
                </div>
              ) : (
                <button className="login-btn" onClick={onOpenLogin}>
                  👤 Accedi
                </button>
              )}
            </div>

            <Link to="/cart" className="cart-link">
              <span className="cart-icon">🛒</span>
              <span className="cart-count">{cartCount}</span>
            </Link>
          </div>
        </div>
      </div>

      <nav className="header-nav">
        <Link to="/">Home</Link>
        <Link to="/products">Tutti i Pallet</Link>
        <Link to="/contatti">Contatti</Link>
      </nav>
    </header>
  );
};

export default Header;
